<script>

import IsEqualWithCustomizer from "@/mixins/IsEqualWithCustomizer";

export default {
    name: "VFormModifiedStored",
    props: {
        data: {},
    },
    mixins: [
        IsEqualWithCustomizer,
    ],
    data() {
        return {
            originalData: {},
        }
    },
    computed: {
        wasModified() {
            return this.originalData !== undefined && !this._.isEqual(this.originalData, this.data, this.isEqualWithCustomizer);
        },
    },
    watch: {
        data: {
            handler(v) {
                this.$set(this, 'originalData', this._.cloneDeep(v));
            },
            immediate: true,
        },
        wasModified: {
            handler(v) {
                this.$emit("update:was-modified", v);
            },
            immediate: true,
        },
    },
}
</script>

<template>
    <v-form
        v-bind="$attrs"
        v-on="$listeners"
    >
        <slot v-bind="{wasModified}"></slot>
    </v-form>
</template>

<style scoped lang="scss">

</style>
